/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `timeseries` - timeseries
 * * `rastertimeseries` - rastertimeseries
 * * `savedstate` - savedstate
 * * `results` - results
 * * `rasters` - rasters
 * * `gridadmin` - gridadmin
 * * `geopackage` - geopackage
 * * `geojson` - geojson
 * * `initialwaterlevel` - initialwaterlevel
 * * `initial_substance_concentration` - initial_substance_concentration
 * * `bulklateral` - bulklateral
 * * `bulkcontrol` - bulkcontrol
 * * `bulk_boundaryconditions` - bulk_boundaryconditions
 * * `sqlite` - sqlite
 * * `tables` - tables
 * * `bulktimeseriesrain` - bulktimeseriesrain
 * @export
 */
export const UploadTypeEnum = {
  TIMESERIES: "timeseries",
  RASTERTIMESERIES: "rastertimeseries",
  SAVEDSTATE: "savedstate",
  RESULTS: "results",
  RASTERS: "rasters",
  GRIDADMIN: "gridadmin",
  GEOPACKAGE: "geopackage",
  GEOJSON: "geojson",
  INITIALWATERLEVEL: "initialwaterlevel",
  INITIAL_SUBSTANCE_CONCENTRATION: "initial_substance_concentration",
  BULKLATERAL: "bulklateral",
  BULKCONTROL: "bulkcontrol",
  BULK_BOUNDARYCONDITIONS: "bulk_boundaryconditions",
  SQLITE: "sqlite",
  TABLES: "tables",
  BULKTIMESERIESRAIN: "bulktimeseriesrain",
} as const;
export type UploadTypeEnum = (typeof UploadTypeEnum)[keyof typeof UploadTypeEnum];

export function instanceOfUploadTypeEnum(value: any): boolean {
  for (const key in UploadTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(UploadTypeEnum, key)) {
      if (UploadTypeEnum[key as keyof typeof UploadTypeEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function UploadTypeEnumFromJSON(json: any): UploadTypeEnum {
  return UploadTypeEnumFromJSONTyped(json, false);
}

export function UploadTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UploadTypeEnum {
  return json as UploadTypeEnum;
}

export function UploadTypeEnumToJSON(value?: UploadTypeEnum | null): any {
  return value as any;
}

export function UploadTypeEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): UploadTypeEnum {
  return value as UploadTypeEnum;
}
